import FitnessCenterIcon from "@mui/icons-material/FitnessCenter";
import { styled } from "@mui/material/styles";
import { trainwellColor } from "src/theme/themePrimitives";

export const WorkoutCardImage = styled(FitnessCenterIcon)(({ theme }) => ({
  color: trainwellColor.neutral5, // Specify icon color
  marginRight: theme.spacing(1),
  fontSize: "2rem",
}));
